import { Route, Switch } from 'react-router-dom'
import { asyncComponent } from '../../components/async-component'

const BasicReportsPage = asyncComponent(
  () => import(/* webpackChunkName: "BasicReportsPage" */ './page'),
  'ReportsPage'
)
const BasicReportPage = asyncComponent(() => import(/* webpackChunkName: "BasicReportPage" */ './reports'), 'Tabs')

export const Basic = ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}`} component={BasicReportsPage} />
    <Route path={`${match.path}/:bureau`} component={BasicReportPage} />
  </Switch>
)
